<template>
  <ValidationProvider
    v-slot="{ errors }"
    :bails="provider.Bails"
    :class="provider.Class"
    :immediate="provider.Immediate"
    :name="catalog[field].Label"
    :rules="validationRules"
    :tag="provider.Tag"
    :vid="vid"
  >
    {{ updateErrors(errors) }}
    <b-field :type="{ 'is-danger': errors[0] }">
      <template v-if="!errorOff" #message>
        <kst-list hide-empty :items="getErrors(errors)"/>
      </template>

      <slot name="left" />

      <b-input expanded
        ref="myField"
        type="text"
        v-model="data[field]"
        :disabled="theDisabled"
        :icon="theIcon"
        :id="vid"
        :maxlength="maxlength"
        :rounded="rounded"
        @keydown.native.enter="handleEnter"
        @input="handleInput"
        @focus.native="handleFocus"
      />

      <slot name="right" />
    </b-field>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    field: {
      type: String,
      required: true 
    },
    data: {
      type: Object,
      required: true
    },
    catalog: {
      type: Object,
      required: true
    },
    disabled: Boolean,
    errorOff: Boolean,
    loadOnFocus: Boolean,
    rounded: Boolean,
    vid: String,
    validationRules: {
      type: Object
    },
    // catalog
    provider: Object
  },
  computed: {
    maxlength() {
      if (this.catalog[this.field].Length !== undefined) {
        return this.catalog[this.field].Length;
      }
      else if (this.catalog[this.field].MaxLength !== undefined) {
        return this.catalog[this.field].MaxLength;
      }

      return undefined;
    },
    theDisabled() {
      if (this.disabled === undefined) {
        return this.catalog[this.field].ReadOnly;
      }
      return this.disabled;
    },
    theIcon() {
      if (this.catalog[this.field].Icon) {
        return this.catalog[this.field].Icon;
      }
      return undefined;
    }
  },
  mounted() {
    if (this.loadOnFocus) {
      this.focus();
    }
  },
  methods: {
    focus() {
      this.$refs.myField.focus();
    },

    handleInput() {
      this.$emit(this.$kst.Enum.Event.Input);
    },
    handleFocus(event) {
      this.$emit(this.$kst.Enum.Event.Focus, event);
    },
    handleEnter() {
      this.$emit(this.$kst.Enum.Event.Submit);
    },

    updateErrors(errors) {
      this.$emit(this.$kst.Enum.Event.Error, errors);
    },

    getErrors(errors) {
      let result = [];

      for (const error of errors) {
        if (error !== this.$kst.Vee.ValidRule) {
          result.push(error);
        }
      }

      return result;
    }
  }
}
</script>